import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import attendeeCameraStatus from '@shoflo/studio-redux/reducers/attendee/attendeeCameraStatus';
import attendeeContentShareAudioProfile from '@shoflo/studio-redux/reducers/attendee/attendeeContentShareAudioProfile';
import attendeeDetails from '@shoflo/studio-redux/reducers/attendee/attendeeDetails';
import attendeeMuteStatus from '@shoflo/studio-redux/reducers/attendee/attendeeMuteStatus';
import attendeeNetworkHealth from '@shoflo/studio-redux/reducers/attendee/attendeeNetworkHealth';
import attendeePresence from '@shoflo/studio-redux/reducers/attendee/attendeePresence';
import attendeeReceivedFrame from '@shoflo/studio-redux/reducers/attendee/attendeeReceivedFrame';
import attendeeRoster from '@shoflo/studio-redux/reducers/attendee/attendeeRoster';
import attendeeVoiceIntensity from '@shoflo/studio-redux/reducers/attendee/attendeeVoiceIntensity';
import userBackground from '@shoflo/studio-redux/reducers/backgroundFilters/userBackground';
import backgrounds from '@shoflo/studio-redux/reducers/backgrounds/backgrounds';
import banners from '@shoflo/studio-redux/reducers/banners/banners';
import brandingSettings from '@shoflo/studio-redux/reducers/branding/brandingSettings';
import { broadcast } from '@shoflo/studio-redux/reducers/broadcast/broadcast';
import { broadcastRoles } from '@shoflo/studio-redux/reducers/broadcastRoles/broadcastRoles';
import directorRequests from '@shoflo/studio-redux/reducers/knocks/directorRequests';
import isNotificationListActive from '@shoflo/studio-redux/reducers/knocks/isNotificationListActive';
import knocks from '@shoflo/studio-redux/reducers/knocks/knocks';
import mediaPlayerSettings from '@shoflo/studio-redux/reducers/mediaPlayerSettings/mediaPlayerSettings';
import audioInputDevice from '@shoflo/studio-redux/reducers/meeting/audioInputDevice';
import audioOutputDevice from '@shoflo/studio-redux/reducers/meeting/audioOutputDevice';
import meeting from '@shoflo/studio-redux/reducers/meeting/meeting';
import transformedVideoInputs from '@shoflo/studio-redux/reducers/meeting/transformedVideoInputs';
import videoDeviceLost from '@shoflo/studio-redux/reducers/meeting/videoDeviceLost';
import videoInputDevice from '@shoflo/studio-redux/reducers/meeting/videoInputDevice';
import modal from '@shoflo/studio-redux/reducers/modal/modal';
import notification from '@shoflo/studio-redux/reducers/notification/notification';
import overlays from '@shoflo/studio-redux/reducers/overlay/overlays';
import permissions from '@shoflo/studio-redux/reducers/permissions/permissions';
import featuredPresenter from '@shoflo/studio-redux/reducers/program/featuredPresenter';
import program from '@shoflo/studio-redux/reducers/program/program';
import sceneLayers from '@shoflo/studio-redux/reducers/program/sceneLayers';
import sceneLayout from '@shoflo/studio-redux/reducers/program/sceneLayout';
import sourceOnProgram from '@shoflo/studio-redux/reducers/program/sourceOnProgram';
import startProgram from '@shoflo/studio-redux/reducers/program/startProgram';
import attendeeReadinessCheck from '@shoflo/studio-redux/reducers/readinessCheck/attendeeReadinessCheck';
import readinessCheck from '@shoflo/studio-redux/reducers/readinessCheck/readinessCheck';
import sandboxMeetingSession from '@shoflo/studio-redux/reducers/readinessCheck/sandboxMeetingSession';
import sandboxMeetingStatus from '@shoflo/studio-redux/reducers/readinessCheck/sandboxMeetingStatus';
import showReadinessCheck from '@shoflo/studio-redux/reducers/readinessCheck/showReadinessCheck';
import screenShareCount from '@shoflo/studio-redux/reducers/screenShareCount/screenShareCount';
import serverTimeDelta from '@shoflo/studio-redux/reducers/serverTime/serverTimeDelta';
import sessionState from '@shoflo/studio-redux/reducers/sessionState/sessionState';
import { settings as broadcastSettings } from '@shoflo/studio-redux/reducers/settings/settings';
import dragSource from '@shoflo/studio-redux/reducers/source/dragSource';
import liveSources from '@shoflo/studio-redux/reducers/source/liveSources';
import broadcastSourceDisconnectTimeouts from '@shoflo/studio-redux/reducers/source/sourceDisconnectTimeouts';
import broadcastSources from '@shoflo/studio-redux/reducers/source/sources';
import sourceUpdateStatus from '@shoflo/studio-redux/reducers/source/sourceUpdateStatus';
import stagedSources from '@shoflo/studio-redux/reducers/source/stagedSources';
import uploadStatus from '@shoflo/studio-redux/reducers/source/uploadStatus';
import uploadStatusVisibility from '@shoflo/studio-redux/reducers/source/uploadStatusVisibility';
import canStartStream from '@shoflo/studio-redux/reducers/stream/canStartStream';
import streamEndpoints from '@shoflo/studio-redux/reducers/stream/streamEndpoints';
import tabs from '@shoflo/studio-redux/reducers/tabs/tabs';
import { templates } from '@shoflo/studio-redux/reducers/templates/templates';
import trackableUserEvent from '@shoflo/studio-redux/reducers/trackableUserEvent/trackableUserEvent';
import isLoggedOut from '@shoflo/studio-redux/reducers/user/isLoggedOut/isLoggedOut';
import user from '@shoflo/studio-redux/reducers/user/user/user';
import presenterSettingsSource from '@shoflo/studio-redux/reducers/presenters/presenterSettingsSource';
import team from '@shoflo/studio-redux/reducers/team/team';
import event from '@shoflo/studio-redux/reducers/event/event';

function createRootReducer(history) {
  return combineReducers({
    router: connectRouter(history),
    modal,
    user,
    isLoggedOut,
    startProgram,
    broadcast,
    event,
    program,
    serverTimeDelta,
    mediaPlayerSettings,
    broadcastSettings,
    meeting,
    audioInputDevice,
    audioOutputDevice,
    videoInputDevice,
    banners,
    broadcastSources,
    sceneLayout,
    tabs,
    liveSources,
    attendeeCameraStatus,
    permissions,
    attendeeMuteStatus,
    featuredPresenter,
    knocks,
    streamEndpoints,
    screenShareCount,
    attendeeRoster,
    broadcastSourceDisconnectTimeouts,
    directorRequests,
    sceneLayers,
    backgrounds,
    attendeeNetworkHealth,
    attendeeReceivedFrame,
    isNotificationListActive,
    stagedSources,
    dragSource,
    templates,
    sessionState,
    notification,
    uploadStatusVisibility,
    uploadStatus,
    attendeeDetails,
    canStartStream,
    overlays,
    trackableUserEvent,
    sourceOnProgram,
    brandingSettings,
    sourceUpdateStatus,
    attendeeContentShareAudioProfile,
    readinessCheck,
    showReadinessCheck,
    sandboxMeetingStatus,
    sandboxMeetingSession,
    attendeePresence,
    videoDeviceLost,
    userBackground,
    attendeeReadinessCheck,
    attendeeVoiceIntensity,
    transformedVideoInputs,
    team,
    presenterSettingsSource,
    broadcastRoles
  });
}

export default createRootReducer;
